import styled from 'styled-components';

import { containerStyles } from '@components/PDP/pdp.styles';
import { media } from '@theme/media';

export const Container = styled.div`
  ${containerStyles};
  padding-bottom: 0;

  ${media.tablet} {
    padding-bottom: 0;
  }

  > div {
    padding: 0;

    > div {
      padding-right: 0;
      padding-left: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
`;
